import React from 'react';

import { RouteObject } from 'react-router-dom';

import { ActFormView } from '@/pages/BuildingProfileActDetails/components/BuildingProfileActDetailsNavigation';

const Information = React.lazy(
  () => import('@/pages/BuildingProfileActDetails/views/Information'),
);

const Devices = React.lazy(
  () => import('@/pages/BuildingProfileActDetails/views/Devices'),
);

const Seals = React.lazy(
  () => import('@/pages/BuildingProfileActDetails/views/Seals'),
);

export const buildingProfileActDetailsRoutes: RouteObject[] = [
  {
    index: true,
    element: <Information />,
  },
  {
    path: ActFormView.Devices,
    element: <Devices />,
  },
  {
    path: ActFormView.Seals,
    element: <Seals />,
  },
];
